import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useConfig } from "../context/ConfigContext";
import { fmtPhone, waLink } from "../lib/format";

export const Footer = () => {
  const { config } = useConfig();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink/10 bg-surface">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink/65">{config.tagline || "Premium websites, honestly priced."}</p>
        </div>
        <div className="space-y-3 font-mono text-xs">
          <div className="text-[10px] uppercase tracking-[0.3em] text-ink/60">Site</div>
          <Link className="block text-ink/60 transition-colors hover:text-crimson" to="/pricing" data-testid="footer-link-packages">
            Packages & pricing
          </Link>
          <Link className="block text-ink/60 transition-colors hover:text-crimson" to="/pricing#maintenance" data-testid="footer-link-maintenance">
            Maintenance plan
          </Link>
          <Link className="block text-ink/60 transition-colors hover:text-crimson" to="/faq" data-testid="footer-link-faq">
            FAQ
          </Link>
          <Link className="block text-ink/60 transition-colors hover:text-crimson" to="/contact" data-testid="footer-link-contact">
            Contact
          </Link>
          <Link className="block text-ink/60 transition-colors hover:text-crimson" to="/admin" data-testid="footer-link-admin">
            Admin
          </Link>
        </div>
        <div className="space-y-3 font-mono text-xs">
          <div className="text-[10px] uppercase tracking-[0.3em] text-ink/60">Reach us</div>
          {config.whatsapp_number ? (
            <a data-testid="footer-whatsapp" href={waLink(config.whatsapp_number, "Hi OFFCRAFT!")} target="_blank" rel="noreferrer" className="block text-ink/60 transition-colors hover:text-emerald-600">
              WhatsApp — {fmtPhone(config.whatsapp_number)}
            </a>
          ) : null}
          {config.contact?.email ? (
            <a data-testid="footer-email" href={`mailto:${config.contact.email}`} className="block text-ink/60 transition-colors hover:text-crimson">
              {config.contact.email}
            </a>
          ) : null}
        </div>
      </div>
      <div className="border-t border-ink/10">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-3 px-6 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-ink/55 sm:flex-row">
          <span>© {year} OFFCRAFT — all prices maintained centrally, shown live</span>
          <span>Built like craft</span>
        </div>
      </div>
    </footer>
  );
};
